module.exports = __webpack_public_path__ + "img/dreamweavers-3.27a22dce.webp";